import React, { useEffect, useState } from "react";
import PageName from "../../Components/global/PageName";
import { inventoryServer, server } from "../../server";
import { toast } from "react-toastify";
import {
  TableBodyTR,
  TableHeadingTR,
  TableTD,
  TableTH,
} from "../../styles/tableStyle";
import axios from "axios";
import { IoIosSearch } from "react-icons/io";
import { Pagination } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

export default function DocsList() {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location?.pathname?.split("/")[2];
  const [isTableLoaded, setIsTableLoaded] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [docsCount, setDocsCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState("");
  const [docsList, setDocsList] = useState([]);

  const handleGetDocs = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${server}/docs/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo: pageNo,
          pageSize: pageSize,
          deleted: false,
          searchParams: searchParams,
        },
      });
      setLoading(false);
      setIsTableLoaded(true);
      setDocsList(data?.data);
      setDocsCount(data?.count);
    } catch (e) {
      setLoading(false);
      setIsTableLoaded(false);
      toast.error(e?.response?.data || e?.message);
    }
  };

  useEffect(() => {
    handleGetDocs();
  }, [pageNo, searchParams]);

  return (
    <div>
      <div>
        <PageName title="All Docs" />
      </div>
      {/* search */}
      <div className="mt-4 grid grid-cols-2">
        <div className="justify-start flex items-center ml-4">
          <button
            className="text-white bg-purple-500 hover:bg-purple-600 font-medium hover:underline duration-500 p-2 rounded"
            onClick={() => navigate("../addNewDoc")}
          >
            Add New Document
          </button>
        </div>
        <div className="justify-end flex items-center">
          <input
            className="rounded-full rounded-r-none p-2 px-2 w-72 outline-4 border-r-0 border-gray-300 focus:outline-2 duration-200 focus:outline-gray-600 font-normal"
            placeholder="Search here..."
            value={searchParams}
            onChange={(e) => setSearchParams(e.target.value)}
          />
          <div className="cursor-pointer p-[13px] bg-[#64748b] rounded-r-full px-4">
            <IoIosSearch size={20} className="text-white" />
          </div>
        </div>
      </div>
      <div
        className={`inventories-table mt-4 ${isTableLoaded ? "loaded" : ""}`}
      >
        <table className="p-4 table-auto w-full text-sm text-left border-collapse overflow-hidden rounded-xl">
          <thead>
            <tr className={`${TableHeadingTR} bg-slate-500 text-center`}>
              <th className={`p-2 ${TableTH} text-left`}>Doc Title</th>
              <th className={`p-2 ${TableTH} text-left`}>Version</th>
              <th className={`p-2 ${TableTH} text-left`}>No. of Revisions</th>
              <th className={`p-2 ${TableTH} text-left`}>Created By</th>
              <th className={`p-2 ${TableTH} text-left`}>Created At</th>
              <th className={`p-2 ${TableTH} text-left`}>Edit document</th>
            </tr>
          </thead>
          <tbody className={`${TableBodyTR} `}>
            {docsList?.map((item, index) => (
              <tr
                key={item.id}
                className={`${
                  index % 2 === 0 ? "bg-gray-100" : "bg-white"
                } hover:bg-sky-200 cursor-pointer`}
                onClick={() =>
                  navigate("../doc", { state: { docId: item?.id } })
                }
              >
                <td className={`${TableTD} `}>{item.title || "---"}</td>

                <td className={`${TableTD} `}>{item.version || "---"}</td>
                <td className={`${TableTD} `}>{item.revisions?.length || 0}</td>
                <td className={`${TableTD}`}>{item.createdBy || "---"}</td>
                <td className={`${TableTD}`}>
                  {item.createdAt
                    ? new Date(item.createdAt).toLocaleDateString("en-In")
                    : "---"}
                </td>
                <td
                  className={`${TableTD}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    onMouseDown={() =>
                      navigate("../editDoc", { state: { docId: item?.id } })
                    }
                  >
                    Click here
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="flex justify-center mt-4 pb-4">
          <Pagination
            count={Math.ceil(docsCount / pageSize)}
            page={pageNo}
            onChange={(event, value) => setPageNo(value)}
            color="success"
          />
        </div>
      </div>
    </div>
  );
}
